import React from "react";

const IconArrowUp = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={20}
      viewBox="0 0 16 20"
      fill="none"
      {...props}
    >
      <path
        d="M8.35649 0.480214L15.3915 7.51525C15.5351 7.65877 15.6157 7.85343 15.6157 8.0564C15.6157 8.25938 15.5351 8.45404 15.3915 8.59756C15.248 8.74108 15.0533 8.82172 14.8504 8.82172C14.6474 8.82172 14.4527 8.74109 14.3092 8.59756L8.5804 2.86874L8.58107 18.3384C8.58107 18.5415 8.5004 18.7362 8.35679 18.8798C8.21319 19.0234 8.01842 19.1041 7.81534 19.1041C7.61225 19.1041 7.41748 19.0234 7.27388 18.8798C7.13028 18.7362 7.0496 18.5415 7.0496 18.3384L7.05028 2.86874L1.32146 8.59756C1.17794 8.74109 0.983275 8.82172 0.780302 8.82172C0.577329 8.82172 0.382669 8.74109 0.239146 8.59756C0.095622 8.45404 0.0149914 8.25938 0.0149914 8.05641C0.0149914 7.85343 0.0956221 7.65877 0.239146 7.51525L7.27418 0.480213C7.4177 0.33669 7.61236 0.256059 7.81534 0.256059C8.01831 0.256059 8.21297 0.33669 8.35649 0.480214Z"
        fill="white"
      />
    </svg>
  );
};

export default IconArrowUp;
